<template>
    <div class="wrapper">
        <div class="message_div" v-if="hasData()">
            <img class="message_image" :src="messsageIcon" />
            <span v-if="viewType==5" class="message_text">支持多笔缴费累计合开电子发票~</span>
            <span v-else class="message_text">支持不超过10笔缴费合开电子发票~</span>
        </div>
         <div class="shop_list"  v-if="resultList.length>0">
            <scroll  :allLoaded="allLoaded"
                    :data="resultList"
                    @pulldown="loadData"
                    @loadUp="loadup" >
                <div class="cell" v-for="(v,i) in resultList"
                    append="tree"
                    :index="i"
                    :key="i"   :ref="'cell'+i"> <!--@click="goTodetails(v)"-->
                    <div  v-if="viewType==2"  class="cellBG2" @click="selectItem(i)">
                        <div class="cell_div_left">
                            <img v-if="v.isSelect" class="cell_image_icon"  :src="selectIcon" />
                            <div v-else  class="cell_imageBG_icon"></div>
                        </div>

                        <div class="cell_div_right">

                            <div class="cell_div_right_topdiv">
                                <span class="cell_div_right_title1">工单编号</span>
                                <span class="cell_div_right_title2">{{v.repairNo}}</span>
                            </div>

                            <div class="cell_div_right_div">
                                <text class="cell_div_right_title1">项目名称</text>
                                <text class="cell_div_right_title2">{{v.marketName}}</text>
                            </div>

                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">报修类型</span>
                                <span class="cell_div_right_title2">{{v.repairType}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">创建日期</span>
                                <span class="cell_div_right_title2">{{v.repairTimestr}}</span>
                            </div>
                        </div>


                    </div>

                    <div v-if="viewType==2" class="priceDiv2">
                        <span class="price_price_text">{{v.payAmount|returnFloat}}</span>
                        <span class="price_type_text">元</span>
                    </div>

                    <div  v-if="viewType==3"  class="cellBG1" @click="selectItem(i)">
                        <div class="cell_div_left">
                            <img v-if="v.isSelect" class="cell_image_icon"  :src="selectIcon" />
                            <div v-else  class="cell_imageBG_icon"></div>
                        </div>
                        <div class="cell_div_right">
                            <div class="cell_div_right_topdiv">
                                <span class="cell_div_right_title1">月份</span>
                                <span class="cell_div_right_title2">{{v.billCycle}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">账单编号</span>
                                <span class="cell_div_right_title2">{{v.orderNo}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">客商名称</span>
                                <span class="cell_div_right_title2">{{v.companyName}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">所属项目</span>
                                <span class="cell_div_right_title2">{{v.marketName}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">缴费日期</span>
                                <span class="cell_div_right_title2">{{v.payTimestr}}</span>
                            </div>
                        </div>
                         <div  class="priceDiv1">
                            <span class="price_price_text">{{v.payAmount|returnFloat}}</span>
                            <span class="price_type_text">元</span>
                        </div>
                    </div>


                    <div  v-if="viewType==4"  class="cellBG2" @click="selectItem(i)">
                        <div class="cell_div_left">
                            <img v-if="v.isSelect" class="cell_image_icon"  :src="selectIcon" />
                            <div v-else  class="cell_imageBG_icon"></div>
                        </div>

                        <div class="cell_div_right">
                            <div class="cell_div_right_topdiv">
                                <span class="cell_div_right_title1">停车场</span>
                                <span class="cell_div_right_title2">{{v.parkName}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">所属项目</span>
                                <span class="cell_div_right_title2">{{v.marketName}}</span>
                            </div>

                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">缴费月数</span>
                                <span class="cell_div_right_title2">{{v.paymentMonth}}个月</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">缴费日期</span>
                                <span class="cell_div_right_title2">{{v.payTimestr}}</span>
                            </div>
                        </div>
                        <div class="priceDiv2">
                            <span class="price_price_text">{{v.payAmount|returnFloat}}</span>
                            <span class="price_type_text">元</span>
                        </div>
                    </div>


                    <div  v-if="viewType==5"  class="cellBG1"  @click="selectItem(i)">
                        <div class="cell_div_left">
                            <img v-if="v.isSelect" class="cell_image_icon"  :src="selectIcon"/>
                            <div v-else  class="cell_imageBG_icon"></div>
                        </div>
                        <div class="cell_div_right">
                            <div class="cell_div_right_topdiv">
                                <span class="cell_div_right_title1">停车场</span>
                                <span class="cell_div_right_title2">{{v.parkName}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">所属项目</span>
                                <span class="cell_div_right_title2">{{v.marketName}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">进场时间</span>
                                <span class="cell_div_right_title2">{{v.inTime}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">缴费时间</span>
                                <span class="cell_div_right_title2">{{v.payTime}}</span>
                            </div>
                        </div>
                        <div class="priceDiv1">
                            <span class="price_price_text">{{v.payAmount|returnFloat}}</span>
                            <span class="price_type_text">元</span>
                        </div>
                    </div>


                    <div  v-if="viewType==1"  class="cellBG3" @click="selectItem(i)">
                        <div class="cell_div_left">
                            <img v-if="v.isSelect" class="cell_image_icon"  :src="selectIcon"/>
                            <div v-else  class="cell_imageBG_icon"></div>
                        </div>

                        <div class="cell_div_right">
                            <div class="cell_div_right_topdiv">
                                <span class="cell_div_right_title1">会议室名</span>
                                <span class="cell_div_right_title2">{{v.meetingName}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">所属项目</span>
                                <span class="cell_div_right_title2">{{v.marketName}}</span>
                            </div>
                            <div class="cell_div_right_div">
                                <span class="cell_div_right_title1">预定时间</span>
                                <span class="cell_div_right_title2">{{v.reserveTime}}</span>
                            </div>
                        </div>
                         <div v-if="viewType==1" class="priceDiv3">
                            <span class="price_price_text">{{v.payAmount|returnFloat}}</span>
                            <span class="price_type_text">元</span>
                        </div>
                    </div>


                    <div class="line"></div>

                </div>
            </scroll>
         </div>

         <div class="noMess" v-if="resultList.length==0 && loaded">
          <no-message></no-message>
        </div>

        <div  v-if="hasData()" :class="['buttom_view',isiPhoneX ? 'marginBottom':'']">

            <div class="buttom_view_left" @click="selectAllItem()">
                <div v-if="validateIsSelectAll()==false" class="buttom_view_left_iconDev"></div>
                <img v-else class="buttom_view_left_iconimage"  :src="selectIcon"/>
                <span class="buttom_view_left_title">全选</span>
            </div>


            <div class="buttom_view_center">
            </div>
            <div class="buttom_view_right">
                <div v-if="validateButton()==false" class="buttom_view_right_button_enabled">
                    <span class="buttom_view_right_text">下一步</span>
                </div>
                <div v-else :class="['buttom_view_right_button_select',$store.state.common.theme==3?'button_select_theme3':'' ]" @click="gotoFromAction()">
                    <span class="buttom_view_right_text">下一步</span>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import Scroll from "../../components/scroll";
import NoMessage from "../../components/nomessage";
import {getNoReceiptList} from '../../utils/api';
import { mapState } from "vuex";
import storage from '../../utils/storage';
import util from '../../utils/util';
export default {
        name: "billList",
        components: {
             Scroll,
            NoMessage
        },
        computed: {
            ...mapState({
                    common: state => state.common
            }),
            selectIcon(){
                if(this.$store.state.common.theme==3){
                    return this.selectIcon_3
                }else{
                    return this.selectIcon_0
                }

            }
        },

        data () {
            return {
                title:"账单",
                isiPhoneX:false,
                viewType:1,
                LmarketId:'',
                allLoaded:false,
                loaded:false,
                isLoding:false,

                pageNo:1,
                pageSize:10,
                allpage:1,
                messsageIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA0hJREFUSA29Vk1rFEEQre6ZzW48iAdjgkQIoge9eBFC8hMUjBv1oCJETzkEA+LVX6CXiAdPGhDxoGYTwZ/ghoAXL5qTCgmSVcGPg/nYnWnf695ZZrPZngkRC2q3pqfqva7u6qlWkkPM64kB2YhHRJnzYmQUIYPNsFVRUhWj5qWkF9XZ2bUsOOVzMC9vHBXduAnQMRE1ZH1jI2KgFIVwnUCYz5jMgsThfXXh0Ufn0PmbeLe9MY8nSrI/ui1aT0lB90sjFomgPgm0SAitxzWJ4wfyO7inrs9ubA/pIDRz1w5h6g9BVLYkUTOb7ZHdngNAkrweV7AUk2r8yde0axuhJTPySorBsGxGab/d28VAgLGE7TiXJsVUnJjqpV6bWTH0kxlMxGB5rXomxQkTC6vlsB1Pi1DWSrfsMm42kjl0/pPkwJDI8JRT2hzrJsTi1hC7KZbQVqNR0+LdL+ylDkVOXhTpP+WUNsdQnl2FmMC2HHByGar6NPatL7MSdUFkXx8qdsspbY75hNVNbHJAtFm43I91LtvS9wW23qWzSdsth06Dxwoc5NLSKIzi8B7JzK4TJv8IsyRHXBzBkppy/sg9esbROAjVCL4Me0TKEW45FDPEhzjnVjjY9LcibWeQOo5BV6UZvq3XBudq4wf2A0eBSptjuxASssXkEDjxOCzPi/z85JQ2x/IAOI5VTNMsoiscy1WlCt/H78sib+66CcbIjmN5RCO3OK5q0cFcHv82n7CEVgTdraBRh6I3FyUqrKClZJ9FfrgPnxY50TxJHyoiX95mZ8l2FZsVCetVrcae1bCsFds8vTNGmQVFkeNn8Hk76JQ2x7LKnI0ZHOSiBbswg971zTZOO9Dlh52h/sdlxL2j7esWhGF2xCYHxBLaO4gyM8Ju3VXwjkXy/oVI7Z1T2hzzVSkxgZ3cc1oMtkmu9T6VnqAs3p7IppuEYZl9VVrEIdiKKjKwflWNPl9nLm5JCWEHzCTIltBO+G5nIYFCmFWPn71iAIv3miYZAVuEfLB3D9xBZAsXoB6AeZeYETsIYxhLjG33GXq3EXLAkv7SV7AUd9Cpa7iXuI3nS5+wOOjLGMYCI315SkKTzUie2/7/20W4jRUP//Kq/xdCeUlaqrqkIQAAAABJRU5ErkJggg==",
                nodataIcon:"data:image/png;base64,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",
                selectIcon_0:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABA9JREFUWAnNmDtoFFEUhv/Z3URT2IgptIgoBowaUStRREN8NKIikiIq2PnoDD5AC5NIio2aENLaBMFCVFKJSMKKL4I2QoQIYrTSImIhgiZmd/z/uTPO7Li7Mxt3ZQ/cnde553z3v4+ZuxbKtQG7AfNoQQ67YKMdFjYwRKMbZob33vDeOBJ4jBSm0GX9KCeFFdu5325msk5kcYjJWlgW8Rp/igIpmldymCX0FJIY5b3buGC9k0uURQOl7RVMeo5BjzP4MiaBUwRTyhQ54ZYsvjDGLca4jovWp6hqxZ+n7cMMdI3Sr6YyBqS4d/EnAkuyzGOaUOcJdb+Yc2GF7thJVr3MFl5mxXoHpliEcu4LCpijwn1sYh86LDUzz/4GMjD9bFGXAxLVNXnhYlwoo8CyGCDUhTCUxMw3KVMtGGVSA6WLcihXyPIVStuH+PwuKyWdiiHnil4qs+WgHeGYGvVi+0CD9nJO1OccN6scN8+jmkd1XQ4fuIBsx1nrs1L5XTbL0V/3H2GUXV2nnMrtmlFIi14OE5RwqbPGeE//x1GS2PhKabZq8TQKaQVOVQFmnslUSpkWWuUWA82C3k1zeEHCTRUbO5xJSTb1YDPwbQ4Y+6hUJcyMpddc8bYlnBclsLZiXUWYesIM7wHuHQYedABtTYQppZRUEgNf2gmq0kZ1FldkmguGo3JoL3B6i5MEdYRrqDPnRX+1NomBLAl2WltsGLXyF4sChM2D2Qec2uw/vPESePSe1yn/XsEzxSSLBnVrwQShWhZbfqAFOLaJKii4kdl4CYaRhkIwg6+A8+PsrUINCMV3GVoVujESiMrsXgOMckwIrH0lcOYh8EOK8TrldlNQmUEqc44wDgufR5ocLTRKoXgWCHpiI3BzP7CYs0MBhkPKpCcMjCNioF6cRFJohmRNJVWi1/g0cOUZ0LvDhO1cx9azVd85rU8GxoxgLmXcHi0HxvjOCGgyEohOau3VJ0aRbhfq6HoD5/0uGEYBBGRjMsGfjHPhRS12VAX2T89TKsUStn+CUTADlEnwQyPD5v+MDcWKvSEozaYFdZPXKsGIgSwprg9TfHW8ZevjvTpUmSaoFBVbUs+pPbaAMWPCmF/NjBwZyGLCp+0rpOt2Fr2gY6lzZz7TQRHMlC3lXfqZVvIs81+0esSmoLf5HtEnQHwTiKvWn2P82r6nciq3GGgGwWziRiKXdz9M5c40z4ERbyPpa7KI+69f/JxMVi5XZCTlUk7lds0H0jetxZ2Azd70usLzqsbRjD3l6vK+p5XGB9KVvv5t9DoqVRNKsaWOcgV2HELIB9Id7Si1iVOFakB5MGaj2KeUQSucsqa20kHcmvmzIR+qhv6OCYLVzB9WQSida9s0i3Uc8Ds5Syr+l95voRJJrVBidEgAAAAASUVORK5CYII=",
                selectIcon_3:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOHSURBVHgB7VnNThpRFP7OSAomXfAIPIJs2qJppE+gWzWN8AZ2Je1G3LS4s0+AplG39QnUNEpcyRuUNyirIgnM6bmjpMMwl7nDXMAFX0LCXObOfB/33PN3gQUWSASCRTzUq9lOuluE288xOVkizqpxZmoTu+0+O83XvUwzX662YQmJBdyefVlxHHeDmDcZtGIyh8BNF7ihLh0XyrUWEmBiAb9+VIqpFA7AKCIJCNe9Hg7ff6xdYwLEFtCoV3LIoJ6Y+CiTEzziMO6KOHFuvj//vMtpfrBOXoFRQhpXjbNKKc40YwH3F5UDF3xCoCymh5ysRL0h7zKdYGRCHnlGFbMEoVrYqh1G3xaBuZAfwEDEWAG3Yo+OLCnmCAdUerv97VT3u1aA521kU0HZ5VxBbXQ5r/NO2k3Mac9scpg7JJpn9FYQugINCVJY8v79F4NeHx/Cgl34CqgI+8KQ0nAaWYFn2/+NFwiXnfzaztemf2xkBfgV72HGYPB3Bk6j73Q3gyNhJrSOWYJRXt0+2lvdrpXk+3ifT7wRHBsScCX5PJFZSmwFQr6wUzsZXEqK3Rp3u6QxK6rm8I8NCcikHudGXu09CZqRzqOT/lv0Xw8JYHJnIyCEvHnQXBq6JyDAmWam+fySJORVecp6EyKwsQDxHG2SIkQe2DSdk5S8x5HGCIgHp/xuq1Ze3TnKG7lAC+RDWQy/g4y7Bcvd9PXgu3KBY0VYJK86HP7rYROS1gcM0VnuDHkMrR+3/M+Lm9cLAC+1YPogl/aCpZ8QrQ6JmILZ9PusTyW6vf9mYQSp1LQipmTzqjHmvx5J5u7O9h9iR+OI0s8WefF8TUk78v4xZ5QLXSL+k6u6ToLlyu4mODAiYAnOT0yCEBG2y1KxjOPg2IiANyrflnYfJoFPhPWaWjiJmbaCw+GBrIfIfowWIuLufP/Pc1GUgyX0NJxCBRRU7TnpKsDbR3ZzKklZdM3fcalEWeU7mD9a8tFahFaAsjdi+oR5Q2JKmO0PMDaZ8wIRJ9gPCeEq8r5gGAaj5q60vKug2bZaFPk1FdUjYHzAMUsRpuQVYp3QeIcPTyJymAK8Ikn2XZTZ+BH/iOmikmPx9TJxFzbx5LbL4zZs+LQJ4fVPLR3yqcBZmNUhXxBPK+J189bJ8JhVZZViKpeu5F3BVmFcWD/ofpTekmrPhB10q4JpWWoOmwfdCyyQEP8A/p6Zews5RwMAAAAASUVORK5CYII=',
                resultList:[],
            }
        },

        created() {
            let query = this.$route.query;
            this.viewType = query.viewType;
            this.LmarketId =this.common.marketInfo.id
           // 1：会议室，2：物业报修；3：在线账单；4：个人月租；5：临停缴费
            if(this.viewType ==1){
                this.title ="会议室";
            }else if(this.viewType==2){
                this.title ="物业报修";

            }else if(this.viewType==3){
                this.title ="账单";

            }else  if(this.viewType ==4){
                this.title ="月租车";
            }else  if(this.viewType ==5) {
                this.title = "临停车";
            }
            this.getData();
        },
         activated() {
            var str = storage.getS("InvoicSuccess")
            console.log("in activated    " + str)
            if(str == 'InvoicSuccess'){
                setTimeout(() => {
                    this.$router.replace("/InvoicSuccess")
                }, 100)
            }
         },
        filters:{
            returnFloat(val){
                if(!val){
                    return '0'
                }
                return Number(val).toFixed(2)
            }
        },
        methods: {
            dataFormat: function(date,format){
                var o = {
                    "M+" : date.getMonth()+1, //month
                    "d+" : date.getDate(),    //day
                    "h+" : date.getHours(),   //hour
                    "m+" : date.getMinutes(), //minute
                    "s+" : date.getSeconds(), //second
                    "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
                    "S" : date.getMilliseconds() //millisecond
                }
                if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
                    (date.getFullYear()+"").substr(4 - RegExp.$1.length));
                for(var k in o)if(new RegExp("("+ k +")").test(format))
                    format = format.replace(RegExp.$1,
                        RegExp.$1.length==1 ? o[k] :
                            ("00"+ o[k]).substr((""+ o[k]).length));
                return format;
            },

            validateIsSelectAll: function(){
                var  self=this;
                if(self.resultList.length==0){
                    return false;
                }
                if(this.viewType !=5 &&self.resultList.length>=10){
                     var orderNoList =[];
                    for (var i=0;i<self.resultList.length;i++) {
                        var  item=self.resultList[i];
                        if(item.isSelect == true){
                            orderNoList.push(item)
                        }
                    }
                    if(orderNoList.length>=10){
                        return true;
                    }
                }
                for(var j=0;j<self.resultList.length;j++){
                    if(self.resultList[j].isSelect ==false){
                        return false;
                    }
                }
                return true;
            },
            validateButton: function(){
                var  self=this;
                for(var i=0;i<self.resultList.length;i++){
                    if(self.resultList[i].isSelect ==true){
                        return true;
                    }
                }
                return false;
            },
            selectItem(index){
                console.log("in selectAction");
                var  self=this;
                var  item=self.resultList[index];
                var orderNoList =[];
                for (var i=0;i<self.resultList.length;i++) {
                    var  item1=self.resultList[i];
                    if(item1.isSelect == true){
                        orderNoList.push(item1)
                    }
                }
                if(item.isSelect){
                    item.isSelect=false;
                }else {
                    if(this.viewType !=5 && orderNoList.length>=10){
                        util.showToast("系统仅支持10条缴费记录合并开具电子发票,您已选择了10条数据")
                    }else{
                        item.isSelect=true;
                    }
                }
                self.resultList[index]=item;
                // self.resultList=self.resultList;

            },

            selectAllItem(){
                var  self=this;
                if(this.viewType !=5 &&self.resultList.length>=10){

                    var orderNoList =[];
                    for (var i=0;i<self.resultList.length;i++) {
                        var  item=self.resultList[i];
                        if(item.isSelect == true){
                            orderNoList.push(item)
                        }
                    }
                    if(orderNoList.length>=10){
                        util.showToast("系统仅支持10条缴费记录合并开具电子发票，您已经选择了10条数据")

                    }else{
                        for(var i=0;i<self.resultList.length;i++){
                            var  item=self.resultList[i];
                            if(i<10){
                                item.isSelect =true;
                            }else{
                                item.isSelect =false;
                            }
                            console.log(JSON.stringify(item));
                            self.resultList[i]=item;
                        }
                        util.showToast("系统仅支持10条缴费记录合并开具电子发票，自动为您选择最新10条去开票")
                     }


                }else{
                    for(var i=0;i<self.resultList.length;i++){
                        var  item=self.resultList[i];
                        item.isSelect =true;
                        self.resultList[i]=item;
                    }

                }
            },

            gotoFromAction(){
                var  self=this;
                var orderNoList ='';
                var allAmount=0;
                for (var i=0;i<self.resultList.length;i++) {
                    var  item=self.resultList[i];
                    if(item.isSelect == true){
                        orderNoList =orderNoList+item.orderNo+",";
                        allAmount = allAmount+Number(item.payAmount);
                    }
                }

                if(orderNoList.length>0){
                    orderNoList=orderNoList.substr(0,orderNoList.length-1);
                }

                allAmount=allAmount.toFixed(2);

                var url ="/invoiceFromPage?viewType="+this.viewType+"&orderNoList="+orderNoList +"&allAmount="+allAmount;
                this.$router.push({path:url});
                //  this.$router.replace("/InvoicSuccess")
            },

            hasData:function(){
                var  self=this;
                if(self.resultList.length==0){
                    return false;
                }
                return true;
            },
            hasmoreData:function(){
                var  self=this;
                if(self.pageNo>=self.allpage){
                    return false;
                }
                return this.loadinging;
            },

            getData(){
                var self=this;
                // let weexParams = weex.config.params || {};
                let params = {
                    'marketId': this.LmarketId,
                  //  'userId': weexParams.userId, //"6608155D2DD44DBE8D139C3C9DFD7258",
                    "orderType": this.viewType,
                    "pageNo": this.pageNo,
                    "pageSize": this.pageSize
                }
                console.log(JSON.stringify(params));
                this.isLoding =true;
                // self.resultList = [{payTimestr:'2021-02-01',isSelect:false},{payTimestr:'2021-02-02',isSelect:false},{payTimestr:'2021-02-03',isSelect:false},{payTimestr:'2021-02-01',isSelect:false},{payTimestr:'2021-02-02',isSelect:false},{payTimestr:'2021-02-03',isSelect:false}];
                getNoReceiptList(params).then(res => {
                    this.loaded =true;
                    this.isLoding =false;
                    //toast.close();
                    // console.log(JSON.stringify(res));
                    if(res.res.code=='10000' ){
                        if(res.body.orderList) {
                            var array = res.body.orderList;
                            for(var i=0;i<array.length;i++){
                                var  item =array[i];
                                item.isSelect = false;
                                console.log("isSelect")
                                if(self.viewType==3 ||self.viewType==4) {
                                    var newDate = new Date(item.payTime); //得到普通的时间了
                                    item.payTimestr=this.dataFormat(newDate,"yyyy-MM-dd hh:mm:ss");
                                }

                                if(self.viewType ==2){
                                    var newDate = new Date(item.repairTime); //得到普通的时间了
                                    item.repairTimestr=this.dataFormat(newDate,"yyyy-MM-dd hh:mm:ss");
                                }
                                if(item.payTime){
                                    item.payTime =this.dataFormat(new Date(item.payTime),"yyyy-MM-dd hh:mm:ss");
                                }
                                if(item.inTime){
                                    item.inTime = this.dataFormat(new Date(item.inTime),"yyyy-MM-dd hh:mm:ss");
                                }
                                array [i]=item;
                            }

                            if(self.pageNo==1){
                                self.resultList=array ;
                            }else{
                                self.resultList = self.resultList.concat(array)
                                console.log("" +JSON.stringify(self.resultList))
                            }

                            var  allItem =  res.body.orderSize;
                            self.allpage = allItem/self.pageSize;
                            if(array.length != 10){
                                this.allLoaded =true;
                            }else{
                                this.allLoaded =false;
                            }
                        }
                    }

                })

            },


            //下拉刷新
            loadData(){
                console.log("in loadData");
                if(this.isLoding){
                    return;
                }
                this.pageNo=1;
                this.allLoaded =false;
                this.getData();
                },

            //上拉
            loadup(){
                console.log("in loadup");
                if(this.isLoding){
                    return;
                }
                if(this.allLoaded==true){
                    return;
                }
                this.pageNo=this.pageNo+1;
                this.getData();
            },

    }


}
</script>

<style scoped>

    .wrapper {
        background-color: #FFF;
        height: 100vh;
    }
    .shop_list {
        flex: 1;
        height: 85vh;
    }
   .noMess{
        margin-top:300px;
        margin-left: 0px;
    }

    .list{
        width: 750px;
        margin-bottom:108px;
    }
    .list_ipx{
         margin-bottom:176px;
    }

    .nodata_div{
        width: 750px;
        height: 1102px;
        flex-direction: column;
    }

    .nodata_image{
        margin-left: 295px;
        margin-top: 300px;
        width: 160px;
        height: 160px;
    }

    .nodata_text{
        margin-top:28px ;
        color: #C9C9C9;
        font-size: 34px;
        text-align: center;
        line-height: 48px;
        height: 48px;
        width: 750px;

    }


    .message_div{
        width:750px;
        height:76px;
        background-color:rgba(255,246,238,1);
        flex-direction: row;
        display: flex;
        /* align-items: center; */
    }
    .message_image{
       width: 24px;
       height: 24px;
       margin-left: 28px;
       margin-top: 26px;
    }
    .message_text{
        margin-left: 18px;
        margin-top: 20px;
        height:34px;
        font-size:24px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(255,173,93,1);
        line-height:34px;

    }


    .cellBG1{
        /* height: 282px; */
        display: flex;
        flex-direction: row;
        padding:20px 0;
        position:relative;
        width: 750px;
    }

    .cellBG2{
        height: 234px;
        display: flex;
        flex-direction: row;
        position:relative;
        width: 750px;
        display: flex;
    }

    .cellBG3{
        height: 186px;
         display: flex;
        flex-direction: row;
         position:relative;
        width: 750px;

    }

    .cell_div_left{
        width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .cell_image_icon{

        width: 36px;
        height: 36px;
    }


    .cell_imageBG_icon{
        width: 36px;
        height: 36px;
        border-radius:18px;
        background-color: #ffffff;
        border-width: 2px;
        border-color:#DADADA;
        border-style: solid;

    }


    .cell_div_right{
        width: 650px;
        flex-direction: column;
    }


    .priceDiv1{
        flex: 1;
        right: 40px;
        bottom: 20px;
        flex-direction:row;
        justify-content: flex-end;
        position:absolute;
        display: flex;
        width: 220px;
        height: 50px;
    }


    .priceDiv2{
        flex: 1;
        right: 40px;
        top: 154px;
        flex-direction:row;
        justify-content: flex-end;
        position:absolute;
        height: 50px;

    }


    .priceDiv3{
        flex: 1;
        right: 40px;
        bottom: 20px;
        flex-direction:row;
        justify-content: flex-end;
        position:absolute;
        /* width: 220px; */
        height: 50px;

    }


    .price_price_text{

        color: #333333;
        font-size: 34px;
        text-align: right;
        line-height: 48px;
        height: 48px;
        font-weight:bold;
    }

    .price_type_text{
        margin-top: 2px;
        color: #333333;
        font-size: 24px;
        text-align: right;
        line-height: 48px;
        height: 48px;


    }


    .cell_div_right_topdiv{
        margin-top: 28px;
        display: flex;
        flex-direction: row;
        width: 650px;
        height: 34px;
    }


    .cell_div_right_div{

        margin-top: 14px;
        flex-direction: row;
        width: 650px;
        height: 34px;
        display: flex;

    }

    .cell_div_right_title1{
        margin-left: 4px;
        font-size: 24px;
        text-align: left;
        line-height: 34px;
        color: #999999;
        height: 34px;
        width:100px ;
    }

    .cell_div_right_title2{
        margin-left: 20px;
        font-size: 24px;
        text-align: left;
        line-height: 34px;
        color: #333333;
        height: 34px;
        width:500px ;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        /* background-color: red; */
        /* display: flex; */
    }


    .line{

        margin-top: 2px;
        margin-left: 40px;
        margin-right: 40px;
        background-color: #EAEAEA;
        height: 2px;
        width: 670px;

    }


    .buttom_view{
        width: 750px;
        height: 108px;
        display: flex;
        position:fixed;
        bottom: 0px ;
        flex-direction: row;
        background-color:#fff;
    }
    .marginBottom{
        height:176px;
        padding-bottom:68px;
    }

    .buttom_view_left{
        width: 150px;
        display: flex;
        flex-direction: row;
    }

    .buttom_view_left_iconDev{

        width: 36px;
        height: 36px;
        border-radius:18px;
        background-color: #ffffff;
        border-width: 2px;
        border-color:#dadada;
        border-style: solid;
        margin-left: 40px;
        margin-top: 36px;
        display: flex;

    }
    .buttom_view_left_iconimage{
        width: 36px;
        height: 36px;
        margin-left: 40px;
        margin-top: 36px;


    }

    .buttom_view_left_title{
        margin-top: 34px;
        margin-left: 14px;
        width: 56px;
        height: 40px;
        text-align: center;
        line-height: 38px;
        font-size: 28px;
        color: #333333;
        display: flex;

    }


    .buttom_view_right{
        width: 240px;
        display: flex;
    }


    .buttom_view_center{
        width: 360px;
        display: flex;
    }

    .buttom_view_right_button_enabled{
        margin-right: 40px;
        margin-top: 20px;
        width: 192px;
        height: 68px;
        background-color: #DADADA;
        border-radius: 8px;
        display: flex;
    }

    .buttom_view_right_button_select{
        margin-right: 40px;
        margin-top: 20px;
        width: 192px;
        height: 68px;
        background-color: #0087FF;
        border-radius: 8px;
        display: flex;

    }
    .button_select_theme3{
        background-color: #A1805D;
    }

    .buttom_view_right_text{
        margin-top: 14px;
        color: #ffffff;
        font-size: 28px;
        text-align: center;
        line-height: 38px;
        height: 40px;
        width:192px ;
        /* display: flex; */
    }


    .refresh {
        width: 750px;
        height: 100px;
        background-color: #ffffff;
        display: -ms-flex;
        display: -webkit-flex;
        display: flex;
        -ms-flex-align: center;
        -webkit-align-items: center;
        -webkit-box-align: center;
        align-items: center;
    }

    .loading {
        width: 750px;
        height: 120px;
        display: -ms-flex;
        display: -webkit-flex;
        display: flex;
        background-color: #ffffff;
        -ms-flex-align: center;
        -webkit-align-items: center;
        -webkit-box-align: center;
        align-items: center;
    }


    .indicator-text {
        color: #333333;
        font-size: 30px;
        text-align: center;
    }

    .indicator-text1 {
        margin-top: 30px;
        color: #333333;
        font-size: 30px;
        text-align: center;
    }

    .indicator {
        margin-top: 16px;
        height: 40px;
        width: 40px;
        color: #EAEAEA;
    }


</style>
